// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__An4R5","tabs":"styles_tabs__AA-Ou","tab":"styles_tab__7aOFP","activeTab":"styles_activeTab__HkwvP"};